<template>
  <base-list-table :data="data" :structure="structure" :refreshFunction="refreshPage" @rowClick="selectMessage($event)" />
</template>

<script>
  import { computed, watch } from 'vue';
  import { useStore } from 'vuex';

  export default {
    setup() {
      const store = useStore();
      function refreshPage() {
        if (selectedVehicle.value && selectedVehicle.value.device) store.dispatch('getMessages', { id: selectedVehicle.value.device.id });
      }
      const selectedVehicle = computed(() => store.getters.selectedVehicle);
      const lastHeartbeat = computed(() => store.getters.lastHeartbeat);
      watch(lastHeartbeat, refreshPage);

      const messages = computed(() => store.getters.messages);

      const selectMessage = (message) => {
        store.dispatch('selectMessage', message);
      };

      const structure = {
        title: 'vehicles.messages',
        data: [
          {
            title: 'IMEI',
            fields: [
              {
                name: '_id',
                class: 'text-primary-400',
              },
              {
                name: 'IMEI',
                class: 'font-bold ',
              },
            ],
            span: 1,
          },
          {
            title: 'Creazione',
            field: 'created_at',
            span: 1,
            class: 'text-style',
            format: 'datetime',
          },
          {
            title: 'Viaggi',
            field: 'trips',
            span: 2,
          },
          /* {
                    title: "ID Evento",
                    field: "message",
                    subField: "event_id",
                    span: 1,
                }, */
          {
            title: 'Dati GPS',
            field: 'message',
            subField: 'gps',
            format: 'gps',
            span: 2,
          },
          {
            title: 'Priorità',
            field: 'message',
            subField: 'priority',
            format: 'priority',
            span: 1,
          },
          {
            title: 'timestamp',
            field: 'message',
            subField: 'timestamp',
            format: 'datetime',
            span: 1,
          },
        ],
      };

      return {
        data: messages,
        refreshPage,
        selectMessage,
        structure,
      };
    },
  };
</script>

<style></style>
